import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
const Location = (props) => {
  const { t } = useTranslation();
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "location",
      name: "title",
      validation: "",
      default: "",
      label: "location",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    // {
    //   type: "select",
    //   placeholder: "select",
    //   name: "department",
    //   validation: "",
    //   showItem: "title",
    //   default: "",
    //   label: "department",
    //   required: true,
    //   filter: false,
    //   view: true,
    //   tag: true,
    //   add: true,
    //   update: true,
    //   apiType: "API",
    //   selectApi: "department/select",
    // },
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("location")} - Whistleblowing24`;
  }, [t]);

  return (
    <Container className="noshadow">
      <ListTable
        {...props}
        actions={[]}
        viewDetails={false}
        api={`location`}
        itemTitle={`title`}
        shortName={`location`}
        addPrivilege={true}
        delPrivilege={true}
        updatePrivilege={true}
        attributes={attributes}
        viewOnclick={false}
      ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Location);

